import { Note } from '@card-software/library';
import { ResponseTranslation } from '../Translations';
import { ItemConsumableDetails, ItemDetailsFormGroup } from './item-consumable-details';
import { InputParameter } from './input-parameter';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

export interface Step extends StepBase {
  id: string;
  stepId: number;
}

export interface StepSearch {
  stepIdParam?: number;
  stepName?: string;
}

export interface StepBase {
  name: ResponseTranslation;
  notes: Note[];
  trackConsumption: boolean;
  itemDetails: ItemConsumableDetails[];
  additionalParameters: InputParameter[];
}

// Recipe Interfaces / Models

export interface StepSnapshot {
  step: Step;
  order: number;
}

export function StrictStep(step: unknown): Step {
  return step as Step;
}

// Form Groups

export interface StepSearchForm {
  stepIdParam: FormControl<number | null>;
  stepName: FormControl<string | null>;
}

export interface StepFormGroup {
  name: FormControl<string | null>;
  trackConsumption: FormControl<boolean>;
  itemDetailsFormGroups: FormArray<FormGroup<ItemDetailsFormGroup>>;
  additionalParameters: FormControl<InputParameter[]>;
}
